import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../config/authConfig';

export function LoginPage() {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Error durante el login:', error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-honne-navy via-honne-blue to-accent-600">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          {/* Logo */}
          <div className="text-center mb-8">
            <div className="w-20 h-20 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-honne-navy to-honne-blue flex items-center justify-center">
              <svg className="w-12 h-12 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-honne-navy">
              Cost Optimization
            </h1>
            <p className="text-gray-500 mt-2">
              Plataforma de Assessment AWS
            </p>
          </div>

          {/* Descripción */}
          <div className="mb-8 text-center">
            <p className="text-gray-600 text-sm">
              Inicia sesión con tu cuenta de Microsoft 365 para acceder a la plataforma de optimización de costos AWS.
            </p>
          </div>

          {/* Botón de Login */}
          <button
            onClick={handleLogin}
            className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-[#2F2F2F] hover:bg-[#1F1F1F] text-white font-medium rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            {/* Microsoft Logo */}
            <svg className="w-5 h-5" viewBox="0 0 21 21" fill="none">
              <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
              <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
              <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
              <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
            </svg>
            Iniciar sesión con Microsoft
          </button>

          {/* Footer */}
          <div className="mt-8 pt-6 border-t border-gray-100">
            <p className="text-xs text-gray-400 text-center">
              Solo usuarios autorizados de la organización pueden acceder.
            </p>
          </div>
        </div>

        {/* Branding */}
        <p className="text-center text-white/60 text-sm mt-6">
          Powered by Honne Cloud Consulting
        </p>
      </div>
    </div>
  );
}
